<template>
  <router-link :to="to"
    class="bg-apex-blue-500 hover:bg-apex-blue-300 h-12 text-white rounded-sm font-bold flex items-center justify-center transition-all"
    :class="[$slots.icon ? 'px-4' : 'px-6']">
    <div class="mr-2" v-if="$slots.icon">
      <slot name="icon" />
    </div>
    <slot />
  </router-link>

</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'

defineProps<{
  to: RouteLocationRaw
}>()
</script>